<template>
    <div class="n2-center-container" style="background-color:#fff; padding:10px;">
        <div class="n2-padding n2-text-center">
            <h5>{{$t('pages.account.delete_success.title')}}</h5>
            <div>{{$t('pages.account.delete_success.description')}}</div>
        </div>
    </div>


</template>

<script>


    export default {
        components: {
            
        },
        data: function () {
            return {
            }
        },
        created: function () {
        },
        mounted: async function () {

        },
        methods: {
            
        }
    }
</script>
